// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3PCeP","signatureBlock":"Footer_signatureBlock__3yUOI","signature":"Footer_signature__215jV"};